import moduleInfo from '../module.json';
import type { AppRuntime } from '@ayocore/platform/client/runtime/AppRuntime';
import {
  IconRobot,
  IconHistory,
  IconList,
  IconSettings,
  IconBrain,
  IconDatabase,
} from '@tabler/icons-react';
import { lazy } from 'react';
import { AssistantDockPanel } from './components/dock/AssistantDockPanel';
import { AssistantDockBadge } from './components/dock/AssistantDockBadge';

/**
 * Бутстрап модуля LLM (клиент)
 * Регистрирует dock-панель ассистента и навигацию через рантайм.
 */
export async function setup(app: AppRuntime): Promise<void> {
  const llm = app.useModule(moduleInfo.name, {
    version: moduleInfo.version,
    description: moduleInfo.description,
  });

  // Ассистент — first-class citizen: живёт в правой dock-панели приложения.
  // Бейдж показывает активность при закрытой панели (стрим / ожидание ответа юзера).
  llm.useDock({
    id: 'assistant-dock',
    label: 'Ассистент',
    icon: IconRobot,
    component: AssistantDockPanel,
    badge: AssistantDockBadge,
    order: 5,
  });

  llm.useNavigation([
    {
      icon: IconRobot,
      label: 'Консоль ассистента (dev)',
      url: '/llm/assistant',
      component: lazy(() => import('./components/AssistantConsole')),
      hiddenFromMenu: true,
    },
    {
      icon: IconBrain,
      label: 'Семантический поиск',
      url: '/llm/embedding',
      component: lazy(() => import('./components/EmbeddingSearchConsole')),
      hiddenFromMenu: true,
    },
    {
      icon: IconRobot,
      label: 'LLM Агенты',
      url: '/llm/agents',
      component: lazy(() => import('./components/AgentsList')),
    },
    {
      icon: IconDatabase,
      label: 'LLM модели',
      url: '/llm/models',
      component: lazy(() => import('./components/LlmModelsList')),
    },
    {
      icon: IconSettings,
      label: 'Настройки агента',
      url: '/llm/agents/:id/settings',
      component: lazy(() => import('./components/AgentSettings')),
      hiddenFromMenu: true,
    },
    {
      icon: IconHistory,
      label: 'Запуски агента',
      url: '/llm/agents/:id/runs',
      component: lazy(() => import('./components/AgentRunsList')),
      hiddenFromMenu: true,
    },
    {
      icon: IconList,
      label: 'Шаги запуска',
      url: '/llm/agents/:agentId/runs/:runId/steps',
      component: lazy(() => import('./components/RunStepsList')),
      hiddenFromMenu: true,
    },
  ]);
}
